import { LocalStorage } from '@hotjar/insights-common/lib/storage-factory';

/*
    With REC-283 we've introduced a new record to handle columns visibility.
    The old one is going to be removed so we don't pollute and leave unnecessary information inside the LS.

    REC-286 is going to remove this function.
*/
export const deleteDeprecatedConfigColumnsVisibilityRecord = (): void => {
  const deprecatedKey = 'playbacksConfigColumnsVisibility';

  if (LocalStorage.get(deprecatedKey)) {
    LocalStorage.remove(deprecatedKey);
  }
};
